import { genericColors } from './genericColors';

export const grayTheme = {
  genericColors: { ...genericColors },
  themeColors: {
    controlBar: {
      background: genericColors.grayLight,
      borderBottomColor: genericColors.grayBoulder,
      leftPanel: {
        goBackButtonColor: genericColors.grayBoulder,
        goBackButtonColorOnHover: genericColors.blueBright,
        goBackButtonColorOnActive: genericColors.blueMain,
        dividerColor: 'rgba(151, 151, 151, 0.5)',
        buttonColor: genericColors.grayDark,
        buttonColorOnHover: genericColors.blueBright,
        buttonColorOnActive: genericColors.blueMain,
      },
      rightPanel: {
        icons: {
          bookmarkIcon: {
            colorOnEmpty: 'rgba(228, 115, 34, 0.7)',
            colorOnEmptyAndHover: genericColors.orangeMain,
            colorOnFilled: genericColors.orangeZest,
            colorOnFilledAndHover: genericColors.orangeSandy,
          },
          bookshelfIcon: {
            booksIconColor: genericColors.grayBoulder,
            booksIconColorOnHover: genericColors.blueBright,
            circleBackground: genericColors.grayLight,
            iconColor: genericColors.blueSeagull,
            iconColorOnActive: genericColors.blueMain,
          },
          settingsIcon: {
            color: genericColors.grayDark,
            colorOnHover: genericColors.blueBright,
            colorOnActive: genericColors.blueMain,
          },
          searchIcon: {
            color: genericColors.grayDark,
            colorOnHover: genericColors.blueBright,
            colorOnActive: genericColors.blueMain,
          },
        },
      },
    },
    settingsDropdown: {
      background: genericColors.grayLight,
      borderColor: genericColors.grayLight,
      boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.3)',
      dividerColor: genericColors.gray,
      textColor: genericColors.blackMatt,
      pageModeTogglerBorder: genericColors.gray,
      pageModeTogglerColor: genericColors.gray,
      oldReaderLinkColor: genericColors.blueMain,
      oldReaderLinkColorOnHover: genericColors.blueBright,
    },
    sidebars: {
      background: 'rgba(200, 200, 200, 0.95)',
      toc: {
        textColor: genericColors.blackMatt,
        subTextColor: genericColors.grayDark,
        dividerColor: genericColors.gray,
        itemColor: genericColors.blueMain,
        itemColorOnHover: genericColors.blueBright,
        itemColorOnActive: genericColors.blackMatt,
        itemBackgroundOnActive: 'rgba(106, 160, 241, 0.2)',
      },
      thumbnails: {
        textColor: genericColors.grayDark,
        textColorOnActive: genericColors.blackTotal,
      },
      bookmarks: {
        headerBackground: 'rgba(106, 160, 241, 0.2)',
        pagesColor: genericColors.blueMain,
        textColor: genericColors.blackMatt,
        dateColor: genericColors.grayDark,
        removeColor: genericColors.redMilano,
        dividerColor: genericColors.gray,
      },
    },
    pageContainer: { background: genericColors.grayBoulder },
    footer: {
      background: genericColors.grayBoulder,
      textColor: genericColors.blackTotal,
      progressBar: {
        trackColor: genericColors.gray,
      },
    },
    arrowButtons: {
      color: genericColors.grayDark,
      dropShadow: 'drop-shadow(4px 2px 6px rgba(0, 0, 0, 0.35))',
    },
    zoomButtons: {
      background: 'rgba(200, 200, 200, 0.95)',
      backgroundOnHover: genericColors.grayLight,
      backgroundOnActive: 'rgba(151, 151, 151, 0.95)',
      borderColor: genericColors.grayLight,
      borderColorOnHover: genericColors.grayLight,
      borderColorOnActive: 'rgba(151, 151, 151, 0.95)',
      boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.4)',
      boxShadowOnHover: '0px 3px 8px rgba(0, 0, 0, 0.5)',
      iconColor: genericColors.grayBoulder,
      iconColorOnHover: genericColors.orangeZest,
      iconColorOnActive: genericColors.orangePeachy,
    },
    beta: {
      button: {
        background: genericColors.grayLight,
        backgroundOnHover: genericColors.grayDim,
        backgroundOnActive: genericColors.grayLight,
        border: 'transparent',
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
        iconColor: genericColors.grayBoulder,
        iconColorOnHover: genericColors.orangeSoft,
        iconColorOnActive: genericColors.orangeZest,
      },
      modal: {
        background: genericColors.grayDim,
        borderColor: genericColors.grayLight,
        textColor: genericColors.blackTotal,
        smallTextColor: genericColors.grayDark,
        buttonBackground: genericColors.orangeSoft,
      },
    },
  },
  fontSizes: {
    base: '1rem',
    small: '0.88875rem',
    tiny: '0.79rem',
  },
  backgroundTransitionTime: '0.25s',
};
